/* React hooks */
import { useEffect, useState } from "react";
/* Routing */
import { useNavigate, useParams } from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
/* Components */
import Header from "../../../components/common/Header";
import useAuth from "../../../hooks/useAuth";
import { getNetworkContact, getNetworkInfos } from "../../../api/admin/networkReq";
import Missing from "../../Missing";
import FormNetworkGeneral from "../../../forms/admin/network/FormNetworkGeneral";
import FormNetworkContacts from "../../../forms/admin/network/FormNetworkContact";
import { getCountryList } from "../../../api/admin/addressReq";
import { filterCountryList } from "../../../helper/tools";
import Icon from "../../../components/common/Icon";

export default function ViewNetworkInfos() {
    const imageBaseUrl = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const { id } = useParams();
    const {
        networkMainInfos, setNetworkMainInfos,
        networkContact, setNetworkContact,
        countryList, setCountryList,
    } = useData();
    const navigate = useNavigate();

    const { auth } = useAuth();
    const token = auth.token;
    const [showModal, setShowModal] = useState({
        main: false,
        contact: false,
    });

    const apiNetworkInfos = async () => {
        const response = await getNetworkInfos(token, id);
        setNetworkMainInfos(response);
    }

    const apiCountryList = async () => {
        const response = await getCountryList(token);
        setCountryList(response);
    }

    const selectedCountry = filterCountryList(countryList, networkContact?.country);

    const apiNetworkContactInfos = async () => {
        const response = await getNetworkContact(token, id);
        setNetworkContact(response);
    }

    const handleNetworkMainForm = (e) => {
        e.preventDefault()
        setShowModal({ ...showModal, main: true })
    };

    const handleNetworkContactForm = (e) => {
        e.preventDefault()
        setShowModal({ ...showModal, contact: true })
    };

    useEffect(() => {
        apiNetworkInfos()
        apiNetworkContactInfos()
    }, [id]);

    useEffect(() => {
        apiCountryList()
    }, [token]);

    return (
        <main>
            {(networkMainInfos?.error && id != 0) &&
                <Missing />
            }
            {(!networkMainInfos?.error || id == 0) &&
                <>
                    <Header parent="Réseaux"
                        location={(id != 0)
                            ? "Modification d'un réseau " : "Création d'un réseau"}
                        locationComp={`${networkMainInfos?.name ? networkMainInfos?.name : ""}`}
                        slug="/admin/reseaux"
                    />
                    {!networkMainInfos?.error && id != 0 &&
                        <>
                            {showModal.main &&
                                <div className="modal main-infos">
                                    <FormNetworkGeneral apiNetworkInfos={apiNetworkInfos} setShowModal={setShowModal} legend="Informations générales" />
                                </div>
                            }
                            {showModal.contact &&
                                <div className="modal modal-contact">
                                    <FormNetworkContacts apiNetworkContactInfos={apiNetworkContactInfos} setShowModal={setShowModal} legend="Contacts - Codes postaux" />
                                </div>
                            }
                            <div className="double-fieldset">
                                <fieldset className="network">
                                    <Icon span="Informations générales" source="fa fa-user-group" />
                                    <div className="form-input">
                                        <label>Nom</label>
                                        <span>{networkMainInfos?.name}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Forme juridique</label>
                                        <span>{networkMainInfos?.legalForm?.name}</span>
                                    </div>
                                    <div className="form-input logo">
                                        <label>Logo</label>
                                        <img src={`${imageBaseUrl}/media/logos/${networkMainInfos?.logo}`} alt="Logo du réseau" />
                                    </div>
                                    <div className="form-input">
                                        <label>Code d'habilitation</label>
                                        <span>{networkMainInfos?.authorizationCode}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Date d'immatriculation</label>
                                        <span>{networkMainInfos?.registrationDate}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Siret</label>
                                        <span>{networkMainInfos?.siret}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>TVA intracommunautaire</label>
                                        <span>{networkMainInfos?.tva}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Capital</label>
                                        <span>{networkMainInfos?.capital}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Effectif</label>
                                        <span>{networkMainInfos?.workforce}</span>
                                    </div>
                                    <div className="buttons-container">
                                        <button className="red-button" onClick={handleNetworkMainForm}><i className="fa fa-pen-to-square" /><span>Modifier les informations</span></button>
                                    </div>
                                </fieldset>
                                <fieldset>

                                    <Icon span="Contacts - Codes postaux" source="fa fa-address-book" />
                                    <div className="form-input">
                                        <label>Adresse postale</label>
                                        <span>{networkContact?.address?.address}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Complément d'adresse</label>
                                        <span>{networkContact?.address?.addressComp}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Code postal</label>
                                        <span>{networkContact?.address?.zipcode}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Ville</label>
                                        <span>{networkContact?.address?.city}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Pays</label>
                                        <span>{selectedCountry}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Latitude</label>
                                        <span>{networkContact?.address?.latitude}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Longitude</label>
                                        <span>{networkContact?.address?.longitude}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Téléphone</label>
                                        <span>{networkContact?.phone}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Email</label>
                                        <span>{networkContact?.email}</span>
                                    </div>
                                    <div className="form-input">
                                        <label>Site Internet</label>
                                        <span>{networkContact?.website}</span>
                                    </div>
                                    <div className="buttons-container">
                                        <button className="red-button" onClick={handleNetworkContactForm}><i className="fa fa-pen-to-square" /><span>Modifier les informations</span></button>
                                    </div>

                                </fieldset>
                            </div>
                        </>
                    }
                    {id == 0 &&
                        <>
                            <FormNetworkGeneral setShowModal={setShowModal} legend="Informations générales" />
                        </>
                    }
                    <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left" /><span>Retour</span></button>
                </>
            }
        </main>
    )
}